export default "__VITE_ASSET__DS2tyUGy__"